import type { MigrationStrategies } from 'rxdb';
import type { TaskList } from './taskList.types';

export const taskListSchemaMigrationStrategies: MigrationStrategies = {
  1: (oldDoc: TaskList) => {
    const newDoc = {
      role: 7,
      ...oldDoc,
    };
    return newDoc;
  },
  2: (oldDoc: TaskList) => {
    const newDoc = {
      ...oldDoc,
      leadInspectorName: '',
    };
    return newDoc;
  },
  3: (oldDoc: TaskList) => {
    const newDoc = {
      ...oldDoc,
      clerkId: oldDoc.clerkId || null,
      clerkName: oldDoc.clerkName || null,
      proxyInspector: oldDoc.proxyInspector || null,
    };
    return newDoc;
  },
};
